import axios from 'axios';

export const getTicketTypesByEventIdAdmin = async (id) => {
  const response = await axios.get(`/ticket-types/admin/${id}`);

  return response;
};

export const getTicketTypeById = (eventId, ticketTypeId) => axios.get(`/ticket-types/admin/${eventId}/${ticketTypeId}`);
export const createTicketType = (eventId, data) => axios.post(`/ticket-types/admin/${eventId}`, data);
export const updateTicketType = (eventId, ticketTypeId, data) => axios.put(`/ticket-types/admin/${eventId}/${ticketTypeId}`, data);
export const deleteTicketType = (eventId, ticketTypeId) => axios.delete(`/ticket-types/admin/${eventId}/${ticketTypeId}`);

